import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'utils/components/modal';
import { AnalyticsProvider } from 'app/scripts/services/analytics-provider';
import editSettings from '../../../../actions/spot/edit-settings';
import SelectInput from '../select-input';
import RadioButtonPanel from '../radio-button-panel';
import ConfirmModal from '../../../modals/confirmation-modal';
import StrictExternalUrl from './strict-external-url';
import { sendEventHOC } from 'app/scripts/tracking/sendEventHOC';
import {
  createSettingsChangedPayload,
  createSubPolicyChangedPayload
} from 'app/scripts/components/moderation/preferences/settings-send-event-utils';
import {
  APPROVE_ALL,
  PUBLISH_AND_MODERATE,
  REQUIRE_APPROVAL
} from 'app/scripts/components/moderation/preferences/moderation-constants';
import { openModal } from 'app/scripts/components/moderation-v2/comments-and-posts/modals/state/actions';
import { ModalType } from 'app/scripts/components/moderation-v2/comments-and-posts/modals';
import { createTwoButtonsRenderActions } from 'app/scripts/components/moderation-v2/sharable/components/modals/ConfirmationModal/confirmationModalUtils';
import { connect } from 'react-redux';
import { InfoCircle } from '../../../../../components/info';
import { setStrictExternalUrlsFlag } from '../../../../../spots/spotsActions';

const BLOCK_ALL = 'block_all';

const nameMap = {
  [APPROVE_ALL]: 'Approve all',
  [PUBLISH_AND_MODERATE]: 'Publish and moderate',
  [REQUIRE_APPROVAL]: 'Require approval'
};

var APPROVAL_LEVEL = [
  { value: APPROVE_ALL, text: 'Approve All' },
  { value: PUBLISH_AND_MODERATE, text: 'Publish & Moderate' },
  { value: REQUIRE_APPROVAL, text: 'Require Approval' },
  { value: BLOCK_ALL, text: 'Reject All' }
];

function getState(spot) {
  let moderationMode = spot && spot.defaultPolicy;
  let images = spot && spot.commentsContainingImages;
  let links = spot && spot.commentsContainingExternalLinks;
  let gifs = spot && spot.commentsContainingGifs;
  let state = {
    moderationMode: spot && spot.defaultPolicy,
    urlStrictMode: false,
    isExpend: null,
    moderations: {
      approve_all: { images: APPROVE_ALL, links: APPROVE_ALL, gifs: APPROVE_ALL },
      publish_and_moderate: {
        images: PUBLISH_AND_MODERATE,
        links: PUBLISH_AND_MODERATE,
        gifs: PUBLISH_AND_MODERATE
      },
      require_approval: {
        images: REQUIRE_APPROVAL,
        links: REQUIRE_APPROVAL,
        gifs: REQUIRE_APPROVAL
      }
    }
  };
  if (moderationMode) {
    state.moderations[moderationMode].images = images;
    state.moderations[moderationMode].links = links;
    state.moderations[moderationMode].gifs = gifs;
  }
  return state;
}

class ModerationMainPolicy extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = getState(props.spot);

    this.confirmationModal = React.createRef();
  }

  componentDidMount() {
    switch (this.state.moderationMode) {
      case APPROVE_ALL:
        this.refs.moderationModeApproveAll.toggle();
        break;
      case PUBLISH_AND_MODERATE:
        this.refs.moderationModePublishModerate.toggle();
        break;
      case REQUIRE_APPROVAL:
        this.refs.moderationModeRequireApproval.toggle();
        break;
    }
  }

  getApprovalLevelByValue(value) {
    if (!value) {
      return APPROVAL_LEVEL[0];
    }
    return APPROVAL_LEVEL.filter(level => level.value === value)[0];
  }

  get isUrlStrictMode() {
    return this.state.urlStrictMode;
  }

  openConfirmationModal(value) {
    if (this.state.moderationMode === value) {
      return;
    }

    if (this.state.moderationMode === APPROVE_ALL && this.props.isAIModerationAssistanceEnabled) {
      this.props.openAIWarningModal(() => {
        this.moderationMode = value;
        this.onPolicyChange();
      });
    } else {
      this.moderationMode = value;
      this.confirmationModal.current.show();
    }
  }

  onPolicyChange() {
    this.setState({ moderationMode: this.moderationMode });
    this.context.executeAction(editSettings, {
      spotId: this.props.spot.id,
      defaultPolicy: this.moderationMode,
      commentsContainingExternalLinks: this.moderationMode,
      commentsContainingImages: this.moderationMode,
      commentsContainingGifs: this.moderationMode,
      sendEvent: be_success => {
        this.props.sendEvent({
          type: 'Moderation_policy_selected',
          be_success,
          element: { policy_selected: nameMap[this.moderationMode] }
        });
      }
    });
    AnalyticsProvider.track(`Policy ${this.moderationMode} clicked`);
    this.confirmationModal.current.hide();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var moderationMode = nextProps.spot.defaultPolicy;
    var strictExternalUrlsEnabled = !!nextProps.spot.strictExternalUrlsEnabled;
    var moderations = this.state.moderations;

    moderations[moderationMode] = {
      images: nextProps.spot.commentsContainingImages,
      links: nextProps.spot.commentsContainingExternalLinks,
      gifs: nextProps.spot.commentsContainingGifs
    };
    var state = {
      moderationMode,
      moderations,
      urlStrictMode: strictExternalUrlsEnabled
    };

    this.setState(state);
  }

  onSelectImagesChange(mode, images) {
    var commentsContainingImages = images.value;
    var defaultPolicy = this.state.moderationMode;
    if (mode === defaultPolicy) {
      var spotId = this.props.spot.id;
      var payload = {
        commentsContainingImages,
        spotId,
        sendEvent: be_success => {
          this.props.sendEvent(
            createSubPolicyChangedPayload('Comments containing images', images.text, be_success)
          );
        }
      };
      this.context.executeAction(editSettings, payload);
    }
    var moderations = this.state.moderations;
    moderations[mode].images = commentsContainingImages;
    this.setState({ moderations });
  }

  onSelectLinksChange(mode, links) {
    var commentsContainingExternalLinks = links.value;
    var defaultPolicy = this.state.moderationMode;
    if (mode === defaultPolicy) {
      var spotId = this.props.spot.id;
      var payload = {
        commentsContainingExternalLinks,
        spotId,
        sendEvent: be_success => {
          this.props.sendEvent(
            createSubPolicyChangedPayload('Comments containing links', links.text, be_success)
          );
        }
      };
      this.context.executeAction(editSettings, payload);
    }
    var moderations = this.state.moderations;
    moderations[mode].links = commentsContainingExternalLinks;
    this.setState({ moderations });
  }

  onSelectGifsChange(mode, gifs) {
    var commentsContainingGifs = gifs.value;
    var defaultPolicy = this.state.moderationMode;
    if (mode === defaultPolicy) {
      var spotId = this.props.spot.id;
      var payload = {
        commentsContainingGifs,
        spotId,
        sendEvent: be_success => {
          this.props.sendEvent(
            createSubPolicyChangedPayload('Comments containing gifs', gifs.text, be_success)
          );
        }
      };
      this.context.executeAction(editSettings, payload);
    }
    var moderations = this.state.moderations;
    moderations[mode].gifs = commentsContainingGifs;
    this.setState({ moderations });
  }

  onModerationOptionStrictUrlChange = moderationModeOption => {
    return moderationModeOption === this.state.moderationMode
      ? this.onStrictExternalLinkChange
      : () => {};
  };

  onStrictExternalLinkChange = status => {
    const { spot } = this.props;
    const spotId = spot.id;

    this.props.setStrictExternalUrlsFlag(spotId, status);

    this.props.sendEvent(
      createSettingsChangedPayload(`Strict_detection_links_${this.state.moderationMode}`, status)
    );
  };

  updateExpend(value, name) {
    if (value) {
      this.setState({ isExpend: name });
    } else {
      this.setState({ isExpend: null });
    }
  }

  closeEnableConfirmModal() {
    this.confirmationModal.current.hide();
  }

  render() {
    const info = (
      <InfoCircle
        tooltip={
          "All GIFs are pre-moderated by Giphy. Set GIFs to 'approve all' to streamline moderation."
        }
        iconClassName={'info-icon'}
        containerClassName={'info-icon-container'}
      />
    );

    return (
      <div className="field">
        <div className="field-title">Moderation Main Policy</div>
        <RadioButtonPanel
          ref="moderationModeApproveAll"
          name="moderationMode"
          value={APPROVE_ALL}
          isExpend={this.state.isExpend === APPROVE_ALL}
          updateExpend={this.updateExpend.bind(this)}
          checked={this.state.moderationMode === APPROVE_ALL}
          onChange={this.openConfirmationModal.bind(this)}
          className="panel-body-column"
          title={
            <span>
              <em>Approve All</em> - Approve and publish comments automatically.
            </span>
          }
        >
          <div className="panel-body-wrapper">
            <div className="section">
              <div className="section-title">Comments containing images:</div>
              <SelectInput
                options={APPROVAL_LEVEL}
                onChange={this.onSelectImagesChange.bind(this, APPROVE_ALL)}
                value={this.getApprovalLevelByValue(this.state.moderations[APPROVE_ALL].images)}
                size="regular"
              />
            </div>
            <div className="section">
              <div className="section-title">Comments containing external links:</div>
              <SelectInput
                options={APPROVAL_LEVEL}
                onChange={this.onSelectLinksChange.bind(this, APPROVE_ALL)}
                value={this.getApprovalLevelByValue(this.state.moderations[APPROVE_ALL].links)}
                size="regular"
              />
            </div>
            <div className="section">
              <div className="section-title">Comments containing GIFs:{info}</div>
              <SelectInput
                options={APPROVAL_LEVEL}
                onChange={this.onSelectGifsChange.bind(this, APPROVE_ALL)}
                value={this.getApprovalLevelByValue(this.state.moderations[APPROVE_ALL].gifs)}
                size="regular"
              />
            </div>
          </div>
          <StrictExternalUrl
            status={this.isUrlStrictMode && this.state.moderationMode === APPROVE_ALL}
            onStatusChange={this.onModerationOptionStrictUrlChange(APPROVE_ALL)}
          />
        </RadioButtonPanel>

        <RadioButtonPanel
          ref="moderationModePublishModerate"
          name="moderationMode"
          updateExpend={this.updateExpend.bind(this)}
          value={PUBLISH_AND_MODERATE}
          isExpend={this.state.isExpend === PUBLISH_AND_MODERATE}
          checked={this.state.moderationMode === PUBLISH_AND_MODERATE}
          onChange={this.openConfirmationModal.bind(this)}
          className="panel-body-column"
          title={
            <span>
              <em>Publish & Moderate</em> - Publish automatically but keep comments in Pending
              folder.
            </span>
          }
        >
          <div className="panel-body-wrapper">
            <div className="section">
              <div className="section-title">Comments containing images:</div>
              <SelectInput
                options={APPROVAL_LEVEL.slice(1)}
                onChange={this.onSelectImagesChange.bind(this, PUBLISH_AND_MODERATE)}
                value={this.getApprovalLevelByValue(
                  this.state.moderations[PUBLISH_AND_MODERATE].images
                )}
                size="regular"
              />
            </div>
            <div className="section">
              <div className="section-title">Comments containing external links:</div>
              <SelectInput
                options={APPROVAL_LEVEL.slice(1)}
                onChange={this.onSelectLinksChange.bind(this, PUBLISH_AND_MODERATE)}
                value={this.getApprovalLevelByValue(
                  this.state.moderations[PUBLISH_AND_MODERATE].links
                )}
                size="regular"
              />
            </div>
            <div className="section">
              <div className="section-title">Comments containing GIFs:{info}</div>
              <SelectInput
                options={APPROVAL_LEVEL.slice(1)}
                onChange={this.onSelectGifsChange.bind(this, PUBLISH_AND_MODERATE)}
                value={this.getApprovalLevelByValue(
                  this.state.moderations[PUBLISH_AND_MODERATE].gifs
                )}
                size="regular"
              />
            </div>
          </div>
          <StrictExternalUrl
            status={this.isUrlStrictMode && this.state.moderationMode === PUBLISH_AND_MODERATE}
            onStatusChange={this.onModerationOptionStrictUrlChange(PUBLISH_AND_MODERATE)}
          />
        </RadioButtonPanel>
        <RadioButtonPanel
          ref="moderationModeRequireApproval"
          name="moderationMode"
          isExpend={this.state.isExpend === REQUIRE_APPROVAL}
          updateExpend={this.updateExpend.bind(this)}
          value={REQUIRE_APPROVAL}
          checked={this.state.moderationMode === REQUIRE_APPROVAL}
          onChange={this.openConfirmationModal.bind(this)}
          className="panel-body-column"
          title={
            <span>
              <em>Require Approval</em> - Comments must be approved before they are published.
            </span>
          }
        >
          <div className="panel-body-wrapper">
            <div className="section">
              <div className="section-title">Comments containing images:</div>
              <SelectInput
                options={APPROVAL_LEVEL.slice(2)}
                onChange={this.onSelectImagesChange.bind(this, REQUIRE_APPROVAL)}
                value={this.getApprovalLevelByValue(
                  this.state.moderations[REQUIRE_APPROVAL].images
                )}
                size="regular"
              />
            </div>
            <div className="section">
              <div className="section-title">Comments containing external links:</div>
              <SelectInput
                options={APPROVAL_LEVEL.slice(2)}
                onChange={this.onSelectLinksChange.bind(this, REQUIRE_APPROVAL)}
                value={this.getApprovalLevelByValue(this.state.moderations[REQUIRE_APPROVAL].links)}
                size="regular"
              />
            </div>
            <div className="section">
              <span className="section-title">
                Comments containing GIFs:
                {info}
              </span>
              <SelectInput
                options={APPROVAL_LEVEL.slice(2)}
                onChange={this.onSelectGifsChange.bind(this, REQUIRE_APPROVAL)}
                value={this.getApprovalLevelByValue(this.state.moderations[REQUIRE_APPROVAL].gifs)}
                size="regular"
              />
            </div>
          </div>
          <StrictExternalUrl
            status={this.isUrlStrictMode && this.state.moderationMode === REQUIRE_APPROVAL}
            onStatusChange={this.onModerationOptionStrictUrlChange(REQUIRE_APPROVAL)}
          />
        </RadioButtonPanel>
        <Modal ref={this.confirmationModal}>
          <ConfirmModal
            onClose={this.closeEnableConfirmModal.bind(this)}
            title="Confirm Action"
            onConfirm={this.onPolicyChange.bind(this)}
            description="Changing Moderation Policy mode will affect the production system immediately. Are you sure you want to submit this change?"
          />
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  openAIWarningModal: onConfirm => {
    const modalProps = {
      title: 'Confirm Action',
      description:
        'Changing your Moderation Main Policy while AI Moderation Assist is on will enable the assistant to review pending comments. Turn off AI Moderation Assist if this is not intended',
      renderActions: createTwoButtonsRenderActions({
        primaryButtonOnClick: () => {
          onConfirm();
        },
        primaryButtonLabel: 'Confirm'
      })
    };

    dispatch(openModal({ modalType: ModalType.CONFIRM_GENERAL, modalProps }));
  },
  setStrictExternalUrlsFlag: (spotId, value) => {
    dispatch(setStrictExternalUrlsFlag({ spotId, value }));
  }
});

ModerationMainPolicy.propTypes = {
  spot: PropTypes.object,
  sendEvent: PropTypes.func.isRequired,
  isAIModerationAssistanceEnabled: PropTypes.bool
};

ModerationMainPolicy.contextTypes = {
  executeAction: PropTypes.func.isRequired
};

ModerationMainPolicy.displayName = 'ModerationMode';

export default sendEventHOC(connect(undefined, mapDispatchToProps)(ModerationMainPolicy));
